import { useInfiniteGetList, type RaRecord, type SortPayload } from "ra-core";
import { useMemo } from "react";

/** Records loaded per page by the Operations lists and board columns. */
export const RECORDS_PER_PAGE = 25;

/** Server-paginated records; the next 25 load with `fetchNextPage`. */
export const useInfiniteRecords = <RecordType extends RaRecord>(
  resource: string,
  filter: Record<string, unknown>,
  sort: SortPayload,
) => {
  const {
    data,
    total,
    isPending,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteGetList<RecordType>(resource, {
    pagination: { page: 1, perPage: RECORDS_PER_PAGE },
    sort,
    filter,
  });
  const records = useMemo(
    () => data?.pages.flatMap((page) => page.data) ?? [],
    [data],
  );
  return {
    records,
    total: total ?? 0,
    isPending,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  };
};
